import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import MachineStream from "./MachineStream";

// `streams` is coalesced rather than defaulted: a default parameter only fires on
// `undefined`, and the payload may carry an explicit null before the backend ships.
function MachineStreams({ streams }) {
  const cameras = streams ?? [];
  return (
    <Card>
      <CardHeader>
        <h5 className="card-category">Streams</h5>
        <hr />
      </CardHeader>
      <CardBody>
        {cameras.map((stream) => (
          <MachineStream
            key={stream.public_id}
            location={stream.location}
            forwarder={stream.forwarder}
            slot={stream.slot_number}
            deviceHost={stream.device_host}
            isActive={stream.is_active}
          />
        ))}
      </CardBody>
    </Card>
  );
}

export default MachineStreams;
